import React from 'react';

import { useTranslation } from 'react-i18next';

import InfoCardLink from 'components/application/cards/InfoCardLink';

export default function UserPermissionsAndDivisionAccessInfoCard() {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'settings.users.UserPermissionsAndDivisionAccessInfoCard',
  });

  return (
    <InfoCardLink
      title={i18nT('title')}
      url='https://intercom.help/hands-hq/en/articles/5360816-user-permissions-and-division-access-explained'
    />
  );
}
